export default __webpack_public_path__ + "static/media/feature-strategic-1.90f7b269.png";